import * as styles from "./CardHeadingText.css";
import { WrapperDrawnBorder } from "../wrappers/WrapperDrawnBorder";
import { Paragraph } from "../elements/Paragraph";
import { Heading } from "../elements/Heading";
import { ComponentPropsWithRef } from "react";

export type CardHeadingTextProps = {
  text: string;
  heading: string;
  headingSize?: "default" | "large";
} & styles.HeadingVariants &
  ComponentPropsWithRef<"div">;

export const CardHeadingText = ({
  text,
  heading,
  theme = "neutral",
  headingSize = "default",
  ...props
}: CardHeadingTextProps) => {
  return (
    <div className={styles.card} {...props}>
      <div className={styles.header}>
        <WrapperDrawnBorder className={styles.headerElement}>
          <Heading
            className={styles.heading({ theme: theme, size: headingSize })}
            as="h1"
            size={headingSize == "large" ? "Jumbo" : "XLarge"}
          >
            {heading}
          </Heading>
        </WrapperDrawnBorder>
      </div>

      <WrapperDrawnBorder>
        <div className={styles.text}>
          <Paragraph>{text}</Paragraph>
        </div>
      </WrapperDrawnBorder>
    </div>
  );
};
